import { createSelector } from 'reselect';
import omit from 'lodash/omit';

const productInfoNonDefaultSelector = createSelector(
  (state) => state.productInfo,
  (productInfo) => omit(productInfo, ['DefaultProduct']),
);

export default productInfoNonDefaultSelector;
